import React from 'react';
import { useTranslation } from 'react-i18next';
import { PapiDeviation } from '@wix/da-papi-types';
import { useSubmitField } from '../../hooks/useSubmitField';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import License from '@wix/da-shared-react/pkg/License';
import ButtonFieldLayout from '../../layouts/common/ButtonFieldLayout';
import { useFieldFormPopup } from '../../modals/FieldFormPopup';
import LicenseFormPopup from '../../modals/LicenseFormPopup';
import { initAdapter, fieldToLicense, submitAdapter } from './adapters';
import { withConditionalField } from '../../hoc/withConditionalField';

import s from './LicenseField.scss';

interface Props {
  deviation?: PapiDeviation;
  className?: string;
}

const LicenseField: React.FC<Props> = ({ deviation, className }) => {
  const { t } = useTranslation();

  const {
    id,
    field: { onChange, value: license },
  } = useSubmitField('license', {
    initAdapter,
    submitAdapter,
  });

  const modalProps = useFieldFormPopup(license, onChange);

  return (
    <div className={className}>
      <ButtonFieldLayout
        label={t('deviationSubmit.form.license.label')}
        labelProps={{ id: `${id}-label`, htmlFor: id }}
        bottomSlot={
          license && license !== 'none' ? (
            <License className={s['sample']} showIcons license={fieldToLicense(license)} />
          ) : undefined
        }
      >
        <TextButton variant="main" size="small" onClick={modalProps.toggleModal}>
          {license && license.cc
            ? t('deviationSubmit.form.license.button.edit')
            : t('deviationSubmit.form.license.button.add')}
        </TextButton>
      </ButtonFieldLayout>

      <LicenseFormPopup {...modalProps} />
    </div>
  );
};
LicenseField.displayName = 'LicenseField';

export default withConditionalField(LicenseField, ({ deviation }) => !deviation?.isDreamsofart);
